var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_6980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7701 1.10472L46.2079 10.6669C43.9495 12.9253 40.8369 14.1091 37.6481 13.9304C35.2556 13.7963 32.8124 14.805 31.2045 16.9617C29.3039 19.5106 29.2669 23.1129 31.1067 25.706C32.1927 27.2368 33.692 28.2012 35.3041 28.6306C35.7336 30.2429 36.698 31.7421 38.2288 32.8281C40.8218 34.6679 44.4242 34.6309 46.9731 32.7304C49.1298 31.1224 50.1385 28.6792 50.0044 26.2867C49.8257 23.0979 51.0095 19.9853 53.2679 17.7269L62.8301 8.16475",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4667 28.1614C37.6833 29.4907 34.2488 29.0029 31.9434 26.6975",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2979 44.3472L50.4754 50.5247",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0033 46.112L40.7684 51.407",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3585 40.8173L46.0635 39.0522",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5887 19.6373L13.4111 13.4597",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8836 17.8721L23.1185 12.5771",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5273 23.167L17.8224 24.9321",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23189 62.7647L17.7941 53.2025C20.0525 50.9441 23.1651 49.7603 26.3539 49.9389C28.7464 50.073 31.1895 49.0644 32.7975 46.9077C34.698 44.3588 34.7351 40.7565 32.8953 38.1634C31.8092 36.6326 30.31 35.6682 28.6978 35.2388C28.2684 33.6265 27.304 32.1273 25.7731 31.0413C23.1802 29.2015 19.5778 29.2385 17.0288 31.139C14.8721 32.747 13.8635 35.1902 13.9976 37.5827C14.1763 40.7714 12.9924 43.884 10.734 46.1425L1.17186 55.7046",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5352 35.708C26.3187 34.3786 29.7532 34.8665 32.0586 37.1719",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_6980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBones);
export default __webpack_public_path__ + "static/media/bones.6d1974aa7c0aa2e280e5a0f8a7656c67.svg";
export { ForwardRef as ReactComponent };